import React from 'react';
import { useOfflineToggle } from './useOfflineToggle';
import './OfflineToggle.css';

/**
 * Online/Offline switch.
 *
 * Shows *effective* connectivity: Offline when the user chose offline OR the
 * browser lost its connection. With no network the switch is disabled — you
 * can't force "online" — and it flips back automatically on reconnect.
 *
 * Knob left is online, knob right is offline, so "switched on" reads as the
 * deliberate, non-default state.
 */
const OfflineToggle = ({ className = '', scale = 1 }) => {
  const { offline, isBrowserOnline, isManualOffline, toggle } = useOfflineToggle();

  const title = !isBrowserOnline
    ? 'No internet connection — working offline'
    : isManualOffline
      ? 'Working offline — click to go back online'
      : 'Online — click to work offline';

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={!isBrowserOnline}
      title={title}
      role="switch"
      aria-checked={offline}
      aria-label="Work offline"
      style={scale !== 1 ? { transform: `scale(${scale})`, transformOrigin: 'center' } : undefined}
      className={`offline-toggle ${offline ? 'offline-toggle-offline' : 'offline-toggle-online'} ${className}`}
    >
      <span className="offline-toggle-track">
        <span className="offline-toggle-knob" />
      </span>
      <span className="offline-toggle-label">{offline ? 'Offline' : 'Online'}</span>
    </button>
  );
};

export default OfflineToggle;
